import { searchOf, type PeriodChoice } from '../period/period';
import type { TodayMetric } from './today-types';

/** A page and the period the board shows, so the page behind a number opens on the same days. */
export function withPeriod(path: string, choice: PeriodChoice): string {
  const [base = path, query = ''] = path.split('?');
  const search = new URLSearchParams(query);
  for (const [k, v] of Object.entries(searchOf(choice))) if (v) search.set(k, v);
  return `${base}?${search.toString()}`;
}

/** The page behind each number. */
export const todayPages: Record<TodayMetric, string> = {
  signups: '/admin?sort=signedUp&dir=desc',
  activated: '/admin/funnel?step=firstExport',
  paying: '/admin/funnel?step=paid',
  pages: '/admin/revenue?sort=pages&dir=desc',
  exports: '/admin/usage?feature=export.delivered',
  problems: '/admin/friction',
};
